<template>
  <div>
    <a-table bordered
            :loading="loading"
            :columns="columns"
            :data-source="roleList"
            :pagination="pagination"
            @change="handleTableChange"
            >
      <template slot="headUrl" slot-scope="headUrl">
        <a-avatar shape="square" size="small" icon="role" :src="headUrl"/>
      </template>
      <template slot="lastUpdateTime" slot-scope="lastUpdateTime">
        {{ formatDateTime(lastUpdateTime) }}
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" v-if="hasPerm('/admin/system/role/saveRoleMenus')" class="margin-right-30" @click="openMenu(record)">菜单授权</a>
        <a href="javascript:;" v-if="hasPerm('/admin/system/role/findRoleUsers') || hasPerm('/admin/system/role/findById')" class="margin-right-30" @click="openUsers(record)">用户</a>
        <a href="javascript:;" v-if="hasPerm('/admin/system/role/findById')" class="margin-right-30" @click="lookRoleInfo(record)">查看</a>
        <a href="javascript:;" v-if="hasPerm('/admin/system/role/delete')" style="color: #E84D11;" @click="delRole(record)">删除</a>
      </template>
    </a-table>
    <!-- 删除弹窗 -->
    <a-modal v-model="DELvisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <a-spin :spinning="DelSpinning">
        <div class="delRole">
          <div class="DelTitle">删除</div>
          <img src="~@/assets/image/common/DelHint.png" class="delIcon" alt="" />
          <div class="delHint">是否删除{{ DELroleName }}</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
            <a-button class="confirm" @click="confirm">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal v-model="roleinfoVisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
            >
      <a-spin :spinning="infoSpinning">
        <div class="roleInfo-title">角色详情</div>
        <a-form-model ref="roleInfo" v-bind="layout" :model="roleInfo" :rules="roleInfoFormRules">
          <a-form-model-item has-feedback label="角色名称" prop="name">
            <a-input v-model="roleInfo.name" type="text" :maxLength="150" autocomplete="off" :disabled="!btnShow" />
          </a-form-model-item>

          <a-form-model-item has-feedback label="角色描述" prop="remark">
            <a-input v-model="roleInfo.remark" type="text" autocomplete="off" :maxLength="150" :disabled="!btnShow" />
          </a-form-model-item>
        </a-form-model>

        <div class="roleInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="RoleInfoCancel">取消</a-button>
          <a-button class="btn btn-active" v-if="!btnShow && hasPerm('/admin/system/role/save')" @click="RoleInfoEdit">修改</a-button>
          <a-popconfirm
            title="确定提交修改吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="confirmEdit('roleInfo')"
          >
            <a-button class="btn btn-active" v-if="btnShow" >提交</a-button>
          </a-popconfirm>
        </div>
      </a-spin>
    </a-modal>

    <!-- 关联菜单 -->
    <a-modal v-model="menuVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
    >
      <a-spin :spinning="menuSpinning">
        <div class="userInfo-title">菜单授权</div>
        当前角色名称：
        <a-tag color="blue">
          {{roleByMenu.name}}
        </a-tag>

<!--        <div>{{checkedKeys}}</div>-->

        <a-tree
          v-if="menuList.length"
          v-model="checkedKeys"
          checkable
          checkStrictly
          :selectable="false"
          :selected-keys="selectedKeys"
          :replaceFields="replaceFields"
          :tree-data="menuList"
        />

        <div class="userInfo-btn-wrap">
          <a-button class="btn margin-right-30" type="danger" @click="menuClear">全部清空</a-button>
          <a-button class="btn margin-right-30" type="primary" @click="menuCheckAll">全部选中</a-button>
          <a-button class="btn cancel margin-right-30" @click="menuCancel">取消</a-button>
          <a-popconfirm
            title="确定提交授权吗？"
            ok-text="提交"
            cancel-text="取消"
            @confirm="addPower"
          >
            <a-button class="btn btn-active">授权</a-button>
          </a-popconfirm>

        </div>
      </a-spin>
    </a-modal>


    <!-- 角色用户 -->
    <a-modal v-model="userVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
             width="720px"
    >
      <a-spin :spinning="userSpinning">
        <div class="userInfo-title">角色用户</div>
        当前角色名称：
        <a-tag color="blue">{{ roleByUser.name }}</a-tag>
        <div class="role-user-toolbar">
          <a-button type="primary" size="small" @click="openAddUser">增加用户</a-button>
        </div>
        <a-table
          size="small"
          bordered
          rowKey="id"
          :columns="roleUserColumns"
          :data-source="roleUserList"
          :pagination="false"
        >
          <template slot="forze" slot-scope="forze">
            <a-tag :color="forze ? 'red' : 'green'">{{ forze ? '冻结' : '正常' }}</a-tag>
          </template>
          <template slot="userOp" slot-scope="text, record">
            <a-popconfirm
              title="确定从该角色移除该用户吗？"
              ok-text="移除"
              cancel-text="取消"
              @confirm="confirmRemoveUser(record)"
            >
              <a href="javascript:;" style="color: #E84D11;">移除</a>
            </a-popconfirm>
          </template>
        </a-table>
        <div class="userInfo-btn-wrap">
          <a-button class="btn cancel" @click="userCancel">关闭</a-button>
        </div>
      </a-spin>
    </a-modal>

    <!-- 增加用户 -->
    <a-modal v-model="addUserVisible"
             :mask="true"
             :centered="true"
             :footer="null"
             :maskClosable="true"
             width="720px"
    >
      <a-spin :spinning="addUserSpinning">
        <div class="userInfo-title">增加用户</div>
        <div class="role-user-toolbar">
          <a-input-search
            v-model="addUserKeyword"
            placeholder="账号 / 昵称"
            style="width: 240px"
            @search="searchAddUsers"
            enter-button="查询"
          />
        </div>
        <a-table
          size="small"
          bordered
          rowKey="id"
          :columns="addUserColumns"
          :data-source="addUserList"
          :pagination="addUserPagination"
          :row-selection="addUserRowSelection"
          @change="handleAddUserTableChange"
        />
        <div class="userInfo-btn-wrap">
          <a-button class="btn cancel margin-right-30" @click="addUserCancel">取消</a-button>
          <a-button class="btn btn-active" type="primary" @click="confirmAddUsers">确定增加</a-button>
        </div>
      </a-spin>
    </a-modal>


  </div>
</template>

<script>
import { getIdAndChildren } from '@/utils/util'
import { MenuList } from "api/menu";
import { RoleList, DelRole, RoleInfo, upDataRoleInfo,getRoleMenus,saveRoleMenus,getRoleUsers,addRoleUsers,removeRoleUser } from "api/role";
import { AdminuserList } from "api/adminuser";
import search from "@/components/content/search/Search";
import {hasPermission} from 'utils/hasPermission'

const columns = [
  {title: "角色名称", align: "center", dataIndex: 'name'},
  {title: "描述", align: "center", dataIndex: 'remark'},
  {title: "最后修改时间", align: "center", dataIndex: 'lastUpdateTime', scopedSlots: { customRender: 'lastUpdateTime' }},
  {title: '操作', align: "center",width: 360, dataIndex: 'operation',scopedSlots: { customRender: 'operation' }}
];

const roleUserColumns = [
  {title: "账号", align: "center", dataIndex: 'name'},
  {title: "昵称", align: "center", dataIndex: 'nickname'},
  {title: "手机号", align: "center", dataIndex: 'tel'},
  {title: "单位", align: "center", dataIndex: 'company'},
  {title: "状态", align: "center", dataIndex: 'forze', scopedSlots: { customRender: 'forze' }},
  {title: "操作", align: "center", dataIndex: 'userOp', scopedSlots: { customRender: 'userOp' }},
];

const addUserColumns = [
  {title: "账号", align: "center", dataIndex: 'name'},
  {title: "昵称", align: "center", dataIndex: 'nickname'},
  {title: "手机号", align: "center", dataIndex: 'tel'},
  {title: "单位", align: "center", dataIndex: 'company'},
];

export default {
  name: 'RoleTable',
  components: {
    search
  },
  data() {
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('角色名称不能为空'));
      } else {
        callback();
      }
    };
    return {
      columns,
      roleUserColumns,
      addUserColumns,
      pagination: {
				defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },

      loading: false,
      DelSpinning: false,
      infoSpinning: false,

      pageIndex: 0,
	    pageSize: 10,
      roleName: "",

      roleList: [],

      DELvisible: false,
      DELroleName: "",
      DELroleId: Number,

      roleinfoVisible: false,
      roleInfo: {
        id: "",
        name: "",
        remark: "",
      },
      roleInfoFormRules: {
        name: [{ validator: validateNickname, trigger: 'change'}],
      },
      btnShow: false,

      //菜单授权
      menuList: [],
      //已选中的
      checkedKeys:[],
      //原先选中的
      selectedKeys:[],
      menuVisible: false,
      menuSpinning: false,
      roleByMenu:{},
      replaceFields: {
        children:'children',//后端数组层级的名字
        key:'id', //一般是id
        value: 'id',//onSelect(selectedKeys)的selectedKeys的参数值，便于获取然后返回给后端
        title: 'name'
      },

      // 角色用户
      userVisible: false,
      userSpinning: false,
      roleByUser: {},
      roleUserList: [],
      addUserVisible: false,
      addUserSpinning: false,
      addUserKeyword: '',
      addUserList: [],
      addUserSelectedKeys: [],
      addUserPageIndex: 0,
      addUserPageSize: 10,
      addUserPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
      },

    };
  },
  computed: {
    addUserRowSelection() {
      const { addUserSelectedKeys } = this;
      return {
        selectedRowKeys: addUserSelectedKeys,
        onChange: (selectedRowKeys) => {
          this.addUserSelectedKeys = selectedRowKeys;
        },
        getCheckboxProps: (record) => ({
          disabled: this.roleUserList.some(item => item.id === record.id) || record.id === 1,
        }),
      };
    },
  },
  mounted() {
    this.getRoleListData(this.pageIndex, this.pageSize, this.roleName)
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    formatDateTime(value) {
      if (!value) return '-';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      const hours = `${date.getHours()}`.padStart(2, '0');
      const minutes = `${date.getMinutes()}`.padStart(2, '0');
      const seconds = `${date.getSeconds()}`.padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /**
     * 菜单授权
     *
     */
    getMenuListData() {
      MenuList()
        .then(res => {
          // console.log(res);
          // console.log(res.data);
          if(res.data.length > 0) {
            this.menuList = res.data;
          } else {
            this.menuList = []
            this.$message.error('没有查询到结果！');
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    getRoleMenus(roleId) {
      getRoleMenus(roleId)
        .then(res => {
          console.log('getRoleMenus',res);
          console.log('getRoleMenus',res.data);
          if(res.data.length > 0) {
            this.selectedKeys = res.data.map(item=>{return item.id})
            this.checkedKeys.checked = res.data.map(item=>{return item.id})
            // this.checkedKeys.halfChecked = res.data.map(item=>{return item.id})
            console.log('this.selectedKeys',this.checkedKeys);
          } else {
            console.log('该角色没有授权数据！');
          }
        })
        .catch(err => {
          console.log('获取角色授权数据出错！');
          console.log(err);
        })
    },
    openMenu(record){
      console.log('openMenu(record)',record)
      this.menuVisible = true;
      this.roleByMenu = record;
      this.menuList = []
      this.checkedKeys = {}
      this.getMenuListData()
      this.getRoleMenus(record.id)
    },
    menuCancel(){
      this.menuVisible = false;
      this.menuList = []
      this.checkedKeys = {}
    },
    menuClear(){
      this.selectedKeys = []
      this.checkedKeys.checked = []
    },
    menuCheckAll(){
      let ids = getIdAndChildren(this.menuList,[]);
      this.selectedKeys = ids
      this.checkedKeys.checked = ids
    },
    addPower(){
      saveRoleMenus(this.roleByMenu.id,this.checkedKeys.checked)
        .then(res => {
          this.$message.success('授权成功！');
          this.menuCancel()
        })
        .catch(err => {
          console.log(err);
          this.$message.error('授权失败！'+ (err.msg?err.msg:''));
        })
    },

    openUsers(record) {
      this.roleByUser = record;
      this.userVisible = true;
      this.loadRoleUsers();
    },
    userCancel() {
      this.userVisible = false;
      this.roleUserList = [];
      this.roleByUser = {};
    },
    loadRoleUsers() {
      if (!this.roleByUser || !this.roleByUser.id) return;
      this.userSpinning = true;
      getRoleUsers(this.roleByUser.id)
        .then(res => {
          this.userSpinning = false;
          this.roleUserList = (res && res.data) || [];
        })
        .catch(err => {
          this.userSpinning = false;
          console.log(err);
          this.$message.error('查询角色用户失败');
        })
    },
    confirmRemoveUser(record) {
      removeRoleUser(this.roleByUser.id, record.id)
        .then(() => {
          this.$message.success('移除成功');
          this.loadRoleUsers();
        })
        .catch(err => {
          console.log(err);
          this.$message.error((err && (err.message || err.msg)) || '移除失败');
        })
    },
    openAddUser() {
      this.addUserVisible = true;
      this.addUserKeyword = '';
      this.addUserSelectedKeys = [];
      this.addUserPageIndex = 0;
      this.addUserPagination.current = 1;
      this.searchAddUsers();
    },
    addUserCancel() {
      this.addUserVisible = false;
      this.addUserList = [];
      this.addUserSelectedKeys = [];
    },
    searchAddUsers() {
      this.addUserSpinning = true;
      AdminuserList(this.addUserPageIndex, this.addUserPageSize, this.addUserKeyword)
        .then(res => {
          this.addUserSpinning = false;
          const data = res && res.data;
          this.addUserList = (data && data.rows) || [];
          this.addUserPagination.total = (data && data.total) || 0;
        })
        .catch(err => {
          this.addUserSpinning = false;
          console.log(err);
          this.$message.error('查询用户失败');
        })
    },
    handleAddUserTableChange(pagination) {
      this.addUserPagination.current = pagination.current;
      this.addUserPageIndex = pagination.current - 1;
      this.addUserPageSize = pagination.pageSize;
      this.searchAddUsers();
    },
    confirmAddUsers() {
      if (!this.addUserSelectedKeys.length) {
        this.$message.warning('请先选择用户');
        return;
      }
      this.addUserSpinning = true;
      addRoleUsers(this.roleByUser.id, this.addUserSelectedKeys)
        .then(() => {
          this.addUserSpinning = false;
          this.$message.success('增加成功');
          this.addUserCancel();
          this.loadRoleUsers();
        })
        .catch(err => {
          this.addUserSpinning = false;
          console.log(err);
          this.$message.error((err && (err.message || err.msg)) || '增加失败');
        })
    },

    /**
    *逻辑区
    */
    // 表格页面跳转
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pager.current - 1
      this.getRoleListData(this.pageIndex, this.pageSize, this.roleName)
    },
    // 删除
    delRole(record) {
      this.DELvisible = !this.DELvisible;
      this.DELroleName = record.roleName,
      this.DELroleId = record.id
    },
    // 取消删除
    cancel() {
      this.DELvisible = !this.DELvisible;
    },
    // 查看角色信息
    lookRoleInfo(record) {

      this.getRoleInfo(record.id);
      this.roleinfoVisible = true;
    },
    // 修改
    RoleInfoEdit() {
      this.btnShow = true
    },
    // 取消
    RoleInfoCancel() {
      this.roleinfoVisible = false;
      this.btnShow = false;
      this.roleInfo = {
        id: "",
        name: "",
        remark: "",
      }
    },
    // 确定修改
    confirmEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.setEditRole(this.roleInfo.id, this.roleInfo.name, this.roleInfo.remark)
          this.btnShow = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //
    /**
    *逻辑区
    */
    getRoleListData(pageIndex, pageSize, roleName) {
      this.loading = true;
      RoleList(pageIndex, pageSize, roleName)
        .then(res => {
          console.log(res.data);
          const content = (res.data && res.data.content) || [];
          this.pagination.total = (res.data && res.data.totalCount) || 0;
          this.roleList = content;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log('+++++++++++++++err',err);
        })
    },
    // 确定删除
    confirm() {
      let that = this
      that.DelSpinning = true
      DelRole(this.DELroleId)
        .then(res => {
          console.log(res);
          that.$message.success('删除成功');
          that.getRoleListData(this.pageIndex, this.pageSize, this.roleName);
          that.DelSpinning = false;
          that.DELvisible = false;
        })
        .catch(err => {
          console.log(err);
          that.DelSpinning = false;
          that.DELvisible = false;
          that.$message.error(err.message);
        })
    },
    // 查询角色信息
    getRoleInfo(id) {
      this.infoSpinning = true;
      RoleInfo(id)
        .then(res => {
          this.infoSpinning = false;
          console.log(res);
          const data = res.data;
          this.roleInfo.id = data.id;
          this.roleInfo.name = data.name;
          this.roleInfo.remark = data.remark;
        })
        .catch(err => {
          this.infoSpinning = false;
          console.log(err);
        })
    },
    // 修改角色信息
    setEditRole(id, roleName, roleUid, password, tel) {
      console.log(111);
      this.DelSpinning = true;
      upDataRoleInfo(id, roleName, roleUid, password, tel)
        .then(res => {
          this.DelSpinning = false;
          console.log(res);
          this.$message.success('修改成功');
          this.roleinfoVisible = false
          this.getRoleListData(this.pageIndex, this.pageSize, this.roleName);
        })
        .catch(err => {
          this.DelSpinning = false;
          console.log(err);
          this.$message.error('请重试,修改失败');
        })
    },
    //数字格式化
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
  }
}
</script>

<style  lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delRole {
  text-align: center;
  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }
  .delHint {
    color: #212121;
    font-size: 36px;
    line-height: 90px;
  }
  .btn-wrap {
    text-align: center;
    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}
.roleInfo-title {
  line-height: 10px;
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
}
.roleInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;
  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
.userInfo-title {
  line-height: 10px;
  font-size: 22px;
  text-align: center;
  margin-bottom: 15px;
}
.userInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;
  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
.role-user-toolbar {
  margin: 12px 0;
  display: flex;
  justify-content: flex-end;
}
</style>
